<div class="left">
  <input type="file" #file accept="image/x-png,image/gif,image/jpeg" (change)="onChange()"/>
  <button mat-raised-button color="accent" (click)="onClick()">
    {{'Upload Image' | translate}}
  </button>
  <p>{{filename}}</p>
</div>
<img #preview id="inputUploadImage"/>
